import AuthModule from '../../AuthModule';
import { TrackErrorInput, TrackedErrorPriority } from '../lib/types';
import * as Sentry from '@sentry/react';

class SentryErrorIntegration {
  public name: string = SentryErrorIntegration.id;
  public static id: string = 'SentryErrorIntegration';

  private trackErrorFn: (input: TrackErrorInput) => void;

  constructor(trackErrorFn: (input: TrackErrorInput) => void) {
    this.trackErrorFn = trackErrorFn;
  }

  public captureException(error: Error): void {
    Sentry.captureException(error);
  }

  public setupOnce(): void {}

  public preprocessEvent?(event: any): void {
    if (event.exception) {
      let priority: TrackedErrorPriority = 'normal';
      let message = 'Unhandled error';
      let frames: any[] = [];
      event.exception?.values.forEach((value: any) => {
        message = value.value;
        frames = value.stacktrace?.frames;
        if (frames) {
          // see if we were thrown by our DiagnosticsModule
          const handled = frames.some((frame) =>
            frame.function.includes('trackError'),
          );
          if (handled) {
            return;
          }

          // set priority to passive if the error was thrown from a page
          const lastFrame = frames[frames.length - 1];
          if (lastFrame.filename?.includes('src/pages')) {
            priority = 'passive';
          }
        }

        this.trackErrorFn({
          message,
          priority,
          source: 'sentry',
          errorType: 'unhandled',
          extra: {
            frames,
          },
        });
      });
    }
  }

  public processEvent(event: any): any {
    if (event.exception) {
      const user = AuthModule.user;
      if (user) {
        if (!event.tags) {
          event.tags = {};
        }
        event.tags['userId'] = user.id;
        event.tags['service'] = user.contactCenterId;
      }
    }
    return event;
  }
}

export default SentryErrorIntegration;
